module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AG-8ecc3a3f50b32790f45db77c4e7a6c48.png";